import './App.css';
import React, { useState } from "react";
import logo from './assets/Logo.png';
import heroBanner from './assets/hero-banner.jpg';
import heroBanner1 from './assets/hero-banner1.jpg';
import smartTrading from './assets/smart-trading.jpg';
import quantAlog from './assets/quanto-alog.jpg';
import cardImage1 from "./assets/card-image-1.webp";
import cardImage2 from "./assets/card-image-2.webp";
import cardImage3 from "./assets/card-image-3.webp";
import cardImage4 from "./assets/card-image-4.webp";
import cardImage5 from "./assets/card-image-5.webp";
import '@fortawesome/fontawesome-free/css/all.css';
import PopupForm from "./popup.jsx";
import WebinarPopup from "./webinarPopup.jsx";
function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // const openPopup = () => {
  //   setIsPopupOpen(true);
  // };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className="App">
      <WebinarPopup />

      <header className="App-header">
        <div className='logo-container'>
          <img src={logo} className="App-logo" alt="Golden Bird" />
        </div>
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </div>
        <div className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#what-we-teach">What We Teach</a></li>
            <li><a href="#market-myths">Market Myths</a></li>
            <li><a href="#webinars">Webinars</a></li>
          </ul>
        </div>
      </header>

      <section className="hero-section">
        <div className="hero-banner-wrapper">
          <img src={heroBanner1} alt="Hero Banner" className="hero-banner" />
        </div>
        <div className="hero-content">
          <div className="hero-section-heading">
            <i className="fa-solid fa-arrow-trend-up"></i>
            Education-First Financial Learning
          </div>
          <div className="hero-section-heading-text">
            <h1>Smart Investing & Trading. Informed Decisions. <br/>Real Market Understanding.</h1>
          </div>
          <div className="hero-section-description">
            <p>
              Golden Bird is an education-first platform that helps individuals understand investment and trading concepts and develop the mindset required to make informed decisions in financial markets.
              We focus on clarity, discipline, and real understanding — not hype or shortcuts.
            </p>
          </div>
          <div className="hero-section-cta">
            <button className="button" onClick={() => setShowPopup(true)}>Register for Our Next Webinar</button>
          </div>
        </div>
      </section>

      <section className="about-section" id="about">
        <div className="about-us">
          <div className="about-content">
            <h2>About Us</h2>
            <p>
              At Golden Bird, we believe successful participation in markets begins with knowledge, not tips.
              Our role is to educate and guide individuals by explaining how investment and trading concepts work, how markets function, and how decisions should be approached logically and responsibly.
              We focus purely on learning and awareness, enabling individuals to think independently.
            </p>
          </div>
          <div className="about-us-image">
            <img src={heroBanner} alt="About Us" className="about-image" />
          </div>
        </div>
      </section>

      <section className="what-we-teach" id="what-we-teach">
        <div className="what-we-teach-heading">
          <h2>What We Teach</h2>
          <p>We emphasize how to think before acting, rather than following popular ideas.</p>
        </div>

        <div className="what-we-teach-grid">
          {/* Grid items for what we teach */}
          <div class="what-we-teach-item">
            <div className="icon-container">
              <i className="fa-solid fa-chart-line"></i>
            </div>
            <div className="card-header">Short-term and long-term investment concepts</div>
            <div className="card-description">
              <p>Balancing quick gains with long-term growth strategies.</p>
            </div>
          </div>

          <div class="what-we-teach-item">
            <div className="icon-container">
              <i className="fa-solid fa-landmark"></i>
            </div>
            <div className="card-header">Trading fundamentals and market structure</div>
            <div className="card-description">
              <p>Understanding how markets function and trades are executed.</p>
            </div>
          </div>

          <div class="what-we-teach-item">
            <div className="icon-container">
              <i className="fa-solid fa-chart-bar"></i>
            </div>
            <div className="card-header">Market behavior and price action understanding</div>
            <div className="card-description">
              <p>Reading charts and patterns to anticipate price movements.</p>
            </div>
          </div>

          <div class="what-we-teach-item">
            <div className="icon-container">
              <i className="fa-solid fa-dice"></i>
            </div>
            <div className="card-header">Risk and probability concepts</div>
            <div className="card-description">
              <p>Managing uncertainty with probability and risk control techniques.</p>
            </div>
          </div>

          <div class="what-we-teach-item">
            <div className="icon-container">
              <i className="fa-solid fa-hourglass-half"></i>
            </div>
            <div className="card-header">Time-horizon based decision-making</div>
            <div className="card-description">
              <p>Aligning strategies with short, medium, or long-term goals.</p>
            </div>
          </div>

          <div class="what-we-teach-item">
            <div className="icon-container">
              <i className="fa-solid fa-check-circle"></i>
            </div>
            <div className="card-header">Discipline and consistency in approach</div>
            <div className="card-description">
              <p>Sticking to rules and maintaining a steady trading mindset.</p>
            </div>
          </div>

        </div>
      </section>

      <section className="smart-investing">
        <div className="smart-investing-container">

          <div className="smart-investing-image">
            <img src={smartTrading} alt="About Us" className="smart-investing-images" />
          </div>
          <div className="smart-investing-content">
            <div className="smart-investing-heading">
              Mindset & Logic
            </div>
            <h2>Smart Investing & Trading</h2>
            <p>
              Smart investing and trading begin with the right thinking, not personal financial details.
            </p>
            <p>
              At Golden Bird, we focus on:
            </p>

            <ul>
              <li>
                <div className="icon-container">
                  <i className="fa-solid fa-puzzle-piece"></i>
                </div>
                <h4>Logical and structured market thinking</h4>
              </li>

              <li>
                <div className="icon-container">
                  <i className="fa-solid fa-scale-balanced"></i>
                </div>
                <h4>Understanding risk before opportunity</h4>
              </li>

              <li>
                <div className="icon-container">
                  <i className="fa-solid fa-spa"></i>
                </div>
                <h4> Avoiding emotional and impulsive actions</h4>
              </li>

              <li>
                <div className="icon-container">
                  <i className="fa-solid fa-calendar-check"></i>
                </div>
                <h4>Building discipline in both investing and trading decisions</h4>
              </li>

            </ul>
            <p>Right thinking leads to better long-term participation in markets.</p>
          </div>
        </div>
      </section >

      <section className="market-myths" id="market-myths">
        <h2>Market Myths We Break</h2>
        <p>We help learners move beyond common misconceptions:</p>

        <div className="myths-grid">
          <div className="myth-card">
            <img src={cardImage1} alt="Social Media Strategy" />
            <h4>YouTube or social media strategies are not meant for real markets</h4>
          </div>

          <div className="myth-card">
            <img src={cardImage2} alt="Common Strategy" />
            <h4>A strategy known to everyone works for no one</h4>
          </div>

          <div className="myth-card card">
            <img src={cardImage3} alt="Quick Profits" />
            <h4>Quick profits are not sustainable</h4>
          </div>

          <div className="myth-card">
            <img src={cardImage4} alt="One Approach" />
            <h4>One approach cannot suit every market participant</h4>
          </div>

          <div className="myth-card">
            <img src={cardImage5} alt="Patience and Discipline" />
            <h4>Markets reward understanding, patience, and discipline</h4>
          </div>
        </div>
      </section>

      <section className="trading-section" id="quant-awareness">
        <div className='trading-container'>
          <div className="trading-left">
            <div className='trading-heading-section'>
              Algorithmic Awareness
            </div>
            <h2 className="title">Quant & Algo Trading Awareness</h2>
            <p className="description">
              Modern markets are increasingly influenced by quantitative and algorithmic trading.
            </p>
            <p>At Golden Bird, we provide educational awareness on:</p>
            <ul className="bullet-list">
              <li>What quant and algo trading involves</li>
              <li>The role of data, logic, and systems in decision-making</li>
              <li>Why such approaches require structure, testing, and discipline</li>
            </ul>
            <p className="disclaimer">
              This is conceptual education only, designed to explain how professional market systems operate.
            </p>
          </div>

          <div className="trading-right">
            <img src={quantAlog} alt="Algorithmic Trading" className="trading-image" />
          </div>
        </div>
      </section>

      <section className="how-we-work">
        <h2>How We Work</h2>
        <p>A structured, transparent approach to learning financial markets.</p>

        <div className="how-we-work-grid">
          <div className="how-we-work-card">
            <div className="icon-container">
              <i className="fas fa-chart-line concept-icon"></i>
            </div>
            <h4>Explain investment and trading concepts clearly</h4>
            <p className="concept-desc">Break down complex ideas into simple, actionable knowledge.</p>
          </div>

          <div className="how-we-work-card">
            <div className="icon-container">
              <i className="fas fa-exclamation-triangle concept-icon"></i>
            </div>
            <h4>Discuss risks, timelines, and market realities</h4>
            <p className="concept-desc">Highlight volatility, long‑term horizons, and realistic expectations.</p>
          </div>

          <div className="how-we-work-card">
            <div className="icon-container">
              <i className="fas fa-clock concept-icon"></i>
            </div>
            <h4>Use real-world examples and scenarios</h4>
            <p className="concept-desc">Connect theory with practical cases from everyday markets.</p>
          </div>

          <div className="how-we-work-card">
            <div className="icon-container">
              <i className="fas fa-globe concept-icon"></i>
            </div>
            <h4>Encourage independent, informed decision-making</h4>
            <p className="concept-desc">Promote research, analysis, and personal responsibility in choices.</p>
          </div>

        </div>

      </section>

      <section className="concepts-container">
        <h2 className="concepts-header">Why Choose Golden Bird</h2>
        <div className="concepts-grid">
          <div className="concept-card">
            <i className="fas fa-book-open concept-icon"></i>
            <h3 className="concept-title">Education-first approach</h3>
            <p className="concept-desc">Learning is prioritized over quick gains or shortcuts.</p>
          </div>
          <div className="concept-card">
            <i className="fas fa-lightbulb concept-icon"></i>
            <h3 className="concept-title">Focus on informed decisions</h3>
            <p className="concept-desc">We empower you to analyze and decide with confidence.</p>
          </div>
          <div className="concept-card">
            <i className="fas fa-chart-pie concept-icon"></i>
            <h3 className="concept-title">Investment and trading clarity</h3>
            <p className="concept-desc">Complex strategies explained in simple, practical terms.</p>
          </div>
          <div className="concept-card">
            <i className="fas fa-ban concept-icon"></i>
            <h3 className="concept-title">No copied strategies</h3>
            <p className="concept-desc">We avoid generic templates, focusing on unique insights.</p>
          </div>
          <div className="concept-card">
            <i className="fas fa-handshake concept-icon"></i>
            <h3 className="concept-title">Ethical learning model</h3>
            <p className="concept-desc">Integrity and responsibility guide every lesson we share.</p>
          </div>

          <p>We don’t promise returns — we teach understanding</p>

        </div>
      </section>

      <section className="call-to-action" id="webinars">
        <div className='trading-container'>
          <div className="trading-left">
            <div className='trading-heading-section'>
              Ready to Learn Before You Act?
            </div>
            <h2 className="title">Live, Interactive Learning Sessions</h2>
            <p className="description">
              Join Golden Bird and build the knowledge required to approach investing and trading with confidence and discipline.
            </p>
            <p className="description">Register for the Upcoming Webinar</p>

            <button className="button call-to-action-btn" onClick={() => setShowPopup(true)}>Register for Webinar</button>
          </div>

          <div className="trading-right">
            <div className="concepts-container">
              <h2 className="concepts-header">Live Webinars & Practical Learning</h2>
              <p className="concepts-intro">
                We conduct live, interactive webinars focused on real market understanding.
              </p>
              <ul className="concepts-list">
                <li>
                  <i className="fas fa-sitemap concept-icon"></i>
                  <span>How markets actually function</span>
                </li>
                <li>
                  <i className="fas fa-search concept-icon"></i>
                  <span>How to evaluate ideas before acting</span>
                </li>
                <li>
                  <i className="fas fa-times-circle concept-icon"></i>
                  <span>Common mistakes investors and traders make</span>
                </li>
                <li>
                  <i className="fas fa-hourglass-half concept-icon"></i>
                  <span>How informed decisions are built over time</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* <section class="webinar-hero">
        <div class="webinar-content">

          <h1>
            Still Trading <span>Breakouts</span> Like Everyone Else?
          </h1>

          <p class="subheadline">
            Discover how smart money actually moves the market —
            and why retail traders are always late.
          </p>

          <p class="description">
            In this exclusive webinar, we’ll explore the concepts behind
            market structure, liquidity, and how institutional traders think.
          </p>

          <button class="cta-btn" onclick="openPopup()">Reserve Your Seat</button>

          <p class="disclaimer">
            This webinar focuses on market understanding and education.
            No trading strategies or signals will be provided.
          </p>

        </div>
      </section> */}

      <footer className="footer">
        <div className="footer-content">
          {/* Branding & Description */}
          <div className="footer-section">
            <h2 className="footer-logo"><img src={logo} alt='Golden Bird'></img></h2>
            <p className="footer-desc">
              An education-first platform focused on teaching investment concepts,
              market behavior, and smart thinking.
            </p>
          </div>

          {/* Learning Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Learning</h3>
            <ul className="footer-links">
              <li><a href="#what-we-teach">What We Teach</a></li>
              <li><a href="#market-myths">Market Myths</a></li>
              <li><a href="#quant-awareness">Quant Awareness</a></li>
              <li><a href="#webinars">Webinars</a></li>
            </ul>
          </div>

        </div>

        {/* Disclaimer */}
        <div className="footer-disclaimer">
          Important Disclaimer: Golden Bird provides educational content only. We
          do not provide financial advice, promise returns, or execute trades. All
          investments involve risk, and past performance of any market concept
          does not guarantee future results. Please consult a qualified financial
          advisor before making any investment decisions.
        </div>
      </footer>
      {showPopup && <PopupForm onClose={() => setShowPopup(false)} />}
    </div>
  );
}

export default App;
